/* eslint-disable */
import React from "react";
import RaindropInput from "../raindrop-input/raindrop-input.tsx";
import ModelTag from "../model-tag/model-tag";
import { useState } from "react";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";
import Currency from "../currency/currency.tsx";
import ModelComponent from "../model-component/model-component.tsx";

const ModelComponentOrganisationUser = ({
  id = "organisation_activity__1234fake",
  namePreferred = "Fake",
  nameLegal = "Fake Fakeson",
  email = "fake@example.com",
  dateOfBirth,
  addressLine1,
  addressPostcode,
  addressCity,
  rawData = null,
}) => {
  const colorBorderAccent =
    "border-color-model-organisation-user dark:border-color-dark-model-organisation-user";

  const dropdownComponent = <div>Hello world</div>;
  return (
    <ModelComponent
      modelId={id}
      dropdownComponent={dropdownComponent}
      colorBorderAccent={colorBorderAccent}
      rawData={rawData}
      helperText={nameLegal}
    >
      <RaindropInput
        label="Preferred Name"
        value={namePreferred}
        isEditing={false}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
        icon=""
      />
      <RaindropInput
        label="Legal Name"
        value={nameLegal}
        isEditing={false}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
        icon=""
      />
      <RaindropInput
        label="Email"
        value={email}
        isEditing={false}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
        icon=""
      />
      <RaindropInput
        label="Date of Birth"
        value={dateOfBirth}
        isEditing={false}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
        icon=""
      />
    </ModelComponent>
  );
};

export default ModelComponentOrganisationUser;
